<template>
  <div
    class="pending-changes"
  >
    <div class="popup">
      <div class="head">
        <span
          class="name"
          v-html="$t('affiliates.affiliatesOffers.pending_date', {date: pendingChangesDate})"
        />
        <UiIcon
          :size="20"
          class="close"
          name="times"
          @click="close"
        />
      </div>
      <div
        v-loading="isDataLoading"
        class="popup-body"
      >
        <OfferInfo
          v-if="isOpen"
          :is-diff="true"
          :offer-info="getOfferInfo"
        />
      </div>
      <div
        class="foot t:space-x-8"
        :class="{ 'foot__is-not-edit': !isEditOffer }"
      >
        <UiButton
          v-if="isEditOffer"
          type="negative"
          icon="times"
          @click="cancelScheduledChanges"
        >
          {{ $t(`affiliates.affiliatesOffers.cancel_pand_change`) }}
        </UiButton>
        <UiButton
          filled
          icon="check"
          @click="close"
        >
          {{ $t(`affiliates.cardView.toolbar.btns.close`) }}
        </UiButton>
      </div>
    </div>
    <div class="wrapper" />
  </div>
</template>

<script>
import OfferInfo from '@/components/OfferInfo.vue';
import offerMixin from '@/views/mixins/offer';

export default {
  name: 'PendingChanges',
  components: {
    OfferInfo,
  },
  mixins: [offerMixin],
  props: {
    offerInfo: {
      type: Object,
      default() {
        return {};
      },
    },

    isOpen: {
      type: Boolean,
      required: true,
    },
    isEditOffer: {
      type: Boolean,
      required: true,
    },
    isDataLoading: {
      type: Boolean,
      required: true,
    },
  },
  emits: ['cancelScheduledChanges', 'close'],
  data() {
    return {

    };
  },
  computed: {
    getOfferInfo() {
      if (!this.offerInfo.scheduled_offer_settings) {
        return this.offerInfo.scheduled_offer_settings;
      }

      const { payout_rules, ...restProps } = this.offerInfo.scheduled_offer_settings;
      return {
        ...restProps,
        payout_rules: payout_rules?.map((rule) => ({
          ...rule,
          settings: {
            ...rule.settings,
            rev_share: rule.settings.rev_share ? {
              sport_levels: rule.settings.rev_share.sport_levels,
              casino_levels: 
                this.$_.isEqual(rule.settings.rev_share.sport_levels, rule.settings.rev_share.casino_levels)
                  ? null 
                  : rule.settings.rev_share.casino_levels,
            } : null,
            cpa: rule.settings.cpa?.map(this.genCpaParams) || null,
          },
        })) || null,
      };
    },
    pendingChangesDate() {
      return this.$filters.formatDate3(this.offerInfo.scheduled_changes_effective_timestamp);
    },
  },
  watch: {

  },

  async mounted() {
    window.addEventListener('keyup', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });
  },
  methods: {
    close() {
      this.$emit('close');
    },
    cancelScheduledChanges() {
      this.$emit('cancelScheduledChanges');
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
